<template>
  <DropdownMenuRoot
    v-if="forceFloating || !isMobile"
    v-model:open="open"
    :modal="false"
  >
    <slot></slot>
  </DropdownMenuRoot>
  <DrawerRoot v-else v-model:open="open">
    <slot></slot>
  </DrawerRoot>
</template>

<script setup lang="ts">
import { DropdownMenuRoot } from "reka-ui";
import { DrawerRoot } from "vaul-vue";
import { onMounted } from "vue";
import { useRoute } from "vue-router";

import { useMediaQuery } from "@/lib/composables/media-query";

import { provide } from "./context";

const isMobile = useMediaQuery("(width < 768px) and (pointer: coarse)");

const route = useRoute();

const props = defineProps<{
  forceFloating?: boolean;
  id?: string;
}>();

const context = provide({
  get id() {
    return props.id;
  },
  isNested: false,
  get isMobile() {
    return !props.forceFloating && isMobile.value;
  },

  triggerElement: undefined,
});

const open = defineModel<boolean>("open", { default: false });

onMounted(async () => {
  if (import.meta.env.VITEST) {
    return;
  }

  // This is annoying, but we have to wait a tick because this can trigger before `route` is ready.
  await Promise.resolve(new Promise((resolve) => setTimeout(resolve, 100)));

  const id = props.id;
  if (id === undefined) {
    return;
  }

  const raw = route.query.emphasis;
  if (raw !== id && (!Array.isArray(raw) || !raw.includes(id))) {
    return;
  }

  const first = document.querySelector(`[data-dialog-id="${CSS.escape(id)}"]`);
  if (first !== context.triggerElement?.value) {
    return;
  }

  open.value = true;
});
</script>
